export interface ResourcesRS {
    id?: string;
    name?:string;
    type?: ResourceRS.TypeEnum;
    url?: string;
    file?: File;
    fileReader?: string | ArrayBuffer | null;
    loading?:boolean;

    // --- Campos de la biblioteca de medios ---
    // OJO: en snake_case a proposito. El backend serializa con SNAKE_CASE
    // (spring.jackson.property-naming-strategy) y ademas omite los nulos
    // (default-property-inclusion: non_null), asi que todos son opcionales.
    // El historico migrado no trae content_type ni size_bytes: no son derivables de la URL.
    site_id?: string;
    target?: string;
    original_filename?: string;
    content_type?: string;
    size_bytes?: number;
    created_date?: string;
}

/**
 * Respuesta paginada del backend.
 *
 * total_page va en SINGULAR: asi lo expone la clase PagedResponse del backend.
 * Igual que las respuestas paginadas de pedidos: los campos JSON siguen snake_case.
 */
export interface PagedResourcesRS {
    size?: number;
    page?: number;
    total_page?: number;
    total_elements?: number;
    content?: Array<ResourcesRS>;
    sorted_by?: string;
}

/** Filtros de la biblioteca. Todo opcional: sin filtros lista todas las tiendas del usuario. */
export interface ResourceSearchParams {
    siteId?: string;
    type?: ResourceRS.TypeEnum;
    target?: string;
    q?: string;
    page?: number;
    size?: number;
}

export namespace ResourceRS {
    export type TypeEnum = 'AUDIO' | 'PHOTO' | 'VIDEO' | 'PDF';
    export const TypeEnum = {
        AUDIO: 'AUDIO' as TypeEnum,
        PHOTO: 'PHOTO' as TypeEnum,
        VIDEO: 'VIDEO' as TypeEnum,
        PDF: 'PDF' as TypeEnum
    };
}
